export const COLORS = {
  headingDark: '#141F33',
  bodyDark: '#383838',
  muted: '#738099',
  mutedAlt: '#8C99AD',
  browseTitle: '#121726',
  browseSubtitle: '#8C91A6',
  timeText: '#777777',
  navy: '#23305F',
  white: '#FFFFFF',

  cardBorder: '#E3EBF2',
  divider: '#A7A7A7',
  toolbarBg: '#F6F8FB',
  pillBg: '#E8EAEF',
  hoverRow: '#FAFBFC',
  pressedRow: '#F1F5F9',
  skeleton: '#EDF2F7',
  imagePlaceholder: '#E8EDFC',

  ctaYellow: '#FFE733',
  ctaYellowHover: '#F2D900',
  ctaYellowActive: '#D9C200',
  ctaDisabledBg: '#F5F5F5',
  ctaDisabledText: '#8C99AD',
  liveChipBg: '#FFF2ED',
  liveChipText: '#C72626',
  countBadge: '#FF385C',

  filterBorder: 'rgba(35,48,95,0.18)',
  scopeTrackBg: '#EDF2F7',
  scopeActiveBg: '#23305F',
  filterPlaceholder: '#6B7385',
} as const;

export const FONT = 'Poppins, sans-serif';

export const PICKED_CARD_WIDTH = 320;
export const PICKED_IMAGE_HEIGHT = 467;
